import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { TYPENAME_PROJECT, TYPENAME_USER } from '~/graphql_shared/constants';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { updateText } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/text_markdown.js?vue3';
import { s__ } from '~/locale';
import GenerateDescriptionModal from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/components/ai_generate_issue_description.vue?vue3';

let el;

function initDescriptionModal({
  resourceId = convertToGraphQLId(TYPENAME_PROJECT, document.body.dataset.projectId),
} = {}) {
  if (!el) {
    el = document.createElement('div');
    document.body.appendChild(el);
  }

  Vue.use(VueApollo);

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(),
  });

  const userId = convertToGraphQLId(TYPENAME_USER, gon.current_user_id);

  return new Vue({
    el,
    name: 'GenerateDescriptionModalRoot',
    apolloProvider,
    render: (createElement) =>
      createElement(GenerateDescriptionModal, {
        props: {
          userId,
          resourceId,
        },
        class: 'gl-mb-5',
        on: {
          'content-generated': function contentGenerated(description) {
            const textArea =
              document.querySelector('#issue_description') ||
              document.querySelector('#work-item-description');
            textArea.value = '';

            updateText({
              textArea,
              tag: description,
              cursorOffset: 0,
              wrap: false,
            });
          },
        },
      }),
  });
}

export const generateDescriptionAction = ({ resourceId } = {}) => ({
  title: s__('AI|Generate issue description'),
  description: s__('AI|Create issue description based on a short prompt'),
  handler() {
    initDescriptionModal({ resourceId });

    return Promise.resolve(null);
  },
});
